import { createOpenAI } from "@ai-sdk/openai";
import { envVariables } from "@/lib/envVariables";

/**
 * OpenAI provider configuration
 */
export const openai = createOpenAI({
  apiKey: envVariables.OPENAI_API_KEY,
});

/**
 * Model ID constants for OpenAI models
 */
export const DALL_E_3 = "dall-e-3";

/**
 * Helper function to get OpenAI provider with DALL-E 3 image model
 */
export const dallE3 = () => openai.image(DALL_E_3);